import axios from "axios";


// Parse the configured API base into origin and optional base path.
function parseApiBase() {
  // Force correct base for production domain to match deployed path
  if (typeof window !== 'undefined' && window.location && window.location.host === 'aipowered.islpulse.com') {
    // If your API is mounted behind '/backend', set basePath accordingly.
    return { origin: 'https://aipowered.islpulse.com', basePath: '/backend' };
  }
  const runtimeGlobal = typeof window !== 'undefined' && window.__API_BASE_URL__ ? String(window.__API_BASE_URL__) : null;
  const runtimeStorage = typeof window !== 'undefined' ? (localStorage.getItem('API_BASE_URL') || null) : null;
  const configured = runtimeGlobal || runtimeStorage || process.env.REACT_APP_API_BASE_URL;
  try {
    if (configured) {
      const parsed = new URL(configured, window.location.origin);
      const origin = parsed.origin.replace(/\/+$/, "");
      let basePath = parsed.pathname.replace(/\/+$/, "");
      if (basePath === "/") basePath = "";
      return { origin, basePath };
    }
  } catch (_) {}
  // Default heuristic: if deployed under '/backend', honor it, else use root
  const pathname = (typeof window !== 'undefined' ? window.location.pathname : '') || '';
  const defaultBasePath = pathname.startsWith('/backend') ? '/backend' : '';
  return { origin: window.location.origin.replace(/\/+$/, ""), basePath: defaultBasePath };
}

const { origin: apiOrigin, basePath: apiBasePath } = parseApiBase();

const api = axios.create({
  baseURL: apiOrigin,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Prefix configured basePath for relative URLs to support deployments behind a path (e.g., "/backend").
  if (typeof config.url === "string" && !/^https?:\/\//i.test(config.url)) {
    let url = config.url;
    const ensureLeadingSlash = (s) => (s.startsWith("/") ? s : `/${s}`);
    if (apiBasePath) {
      // Only prefix if not already starting with the basePath
      if (!url.startsWith(apiBasePath + "/") && url !== apiBasePath) {
        url = `${ensureLeadingSlash(apiBasePath)}${ensureLeadingSlash(url)}`;
      }
    } else {
      url = ensureLeadingSlash(url);
    }
    config.url = url;
  }
  return config;
});

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      // Do not force redirect for login endpoint so we can show toast on invalid credentials
      const isAuthLogin = requestUrl.includes('/api/auth/login');

      if (!isAuthLogin) {
        // Token is invalid or expired on protected requests
        localStorage.removeItem('token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// Helper for AI report generation
export const generateAIReport = async ({ testType, scores, answers, overallScore, overallPercentage, userInfo }) => {
  const response = await api.post('/api/ai-report/generate', {
    testType,
    scores,
    answers,
    overallScore,
    overallPercentage,
    userInfo,
  });
  return response.data;
};
